import { environment } from '../../../environments/environment';

export const FIREBASE_CONFIG = environment.firebase;
